
import { useEffect } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import WhatsAppButton from '../../components/feature/WhatsAppButton';

const KVKKPage = () => {
  useEffect(() => {
    document.title = 'KVKK Aydınlatma Metni - LH Global Pass';
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main className="pt-20">
        <section className="py-20">
          <div className="container mx-auto px-4 lg:px-8">
            <div className="max-w-4xl mx-auto">
              <h1 className="text-4xl lg:text-5xl font-bold text-navy mb-8">
                KVKK Aydınlatma Metni
              </h1>
              
              <div className="prose prose-lg max-w-none text-gray-700 leading-relaxed space-y-6">
                <p className="text-sm text-gray-500">Son Güncelleme: 01 Ocak 2025</p>

                <h2 className="text-2xl font-bold text-navy mt-8">1. Veri Sorumlusu</h2>
                <p>
                  6698 sayılı Kişisel Verilerin Korunması Kanunu ("KVKK") uyarınca, kişisel verileriniz; veri sorumlusu olarak LH Global Pass (bundan böyle "Şirket" olarak anılacaktır) tarafından aşağıda açıklanan kapsamda işlenebilecektir.
                </p>
                <p>
                  <strong>Adres:</strong> Fevzi Paşa Mah. 847/1 Sk. No:8 Kat:4 Daire:4/405 Sağlık İş Hanı Konak/İzmir
                  <br />
                  <strong>E-posta:</strong> lhglobalpass@gmail.com
                  <br />
                  <strong>Telefon:</strong> +90 542 267 11 71
                </p>

                <h2 className="text-2xl font-bold text-navy mt-8">2. Kişisel Verilerin İşlenme Amacı</h2>
                <p>
                  Toplanan kişisel verileriniz, KVKK'nın 5. ve 6. maddelerinde belirtilen kişisel veri işleme şartları ve amaçları dahilinde, <strong>İzmir vize danışmanlığı</strong> hizmetlerimizin sunulması, vize başvuru süreçlerinin yönetilmesi, müşteri ilişkilerinin geliştirilmesi, hukuki yükümlülüklerin yerine getirilmesi ve iletişim faaliyetlerinin yürütülmesi amaçlarıyla işlenebilecektir.
                </p>

                <h2 className="text-2xl font-bold text-navy mt-8">3. İşlenen Kişisel Veriler</h2>
                <p>Şirketimiz tarafından işlenen kişisel veriler şunlardır:</p>
                <ul className="list-disc pl-6 space-y-2">
                  <li>Kimlik Bilgileri (ad, soyad, T.C. kimlik numarası, doğum tarihi, pasaport bilgileri)</li>
                  <li>İletişim Bilgileri (telefon numarası, e-posta adresi, adres)</li>
                  <li>Finansal Bilgiler (banka hesap bilgileri, ödeme bilgileri)</li>
                  <li>Seyahat Bilgileri (vize türü, seyahat tarihleri, destinasyon)</li>
                  <li>Görsel ve İşitsel Kayıtlar (fotoğraf, ofis güvenlik kamera kayıtları)</li>
                  <li>Mesleki Bilgiler (meslek, iş yeri bilgileri)</li>
                </ul>

                <h2 className="text-2xl font-bold text-navy mt-8">4. Kişisel Verilerin Toplanma Yöntemi</h2>
                <p>
                  Kişisel verileriniz, <strong>İzmir vize danışmanlığı</strong> hizmetlerimizden faydalanmanız sırasında; web sitemiz, e-posta, telefon, WhatsApp, yüz yüze görüşmeler ve başvuru formları aracılığıyla toplanmaktadır.
                </p>

                <h2 className="text-2xl font-bold text-navy mt-8">5. Kişisel Verilerin Aktarılması</h2>
                <p>
                  Toplanan kişisel verileriniz, KVKK'nın 8. ve 9. maddelerinde belirtilen kişisel veri işleme şartları ve amaçları çerçevesinde; vize başvurusu yapılan ülkelerin konsoloslukları, vize başvuru merkezleri, hukuki danışmanlar, mali müşavirler ve yasal yükümlülükler gereği kamu kurum ve kuruluşları ile paylaşılabilecektir.
                </p>

                <h2 className="text-2xl font-bold text-navy mt-8">6. Kişisel Veri Sahibinin Hakları</h2>
                <p>KVKK'nın 11. maddesi uyarınca, kişisel veri sahipleri olarak aşağıdaki haklara sahipsiniz:</p>
                <ul className="list-disc pl-6 space-y-2">
                  <li>Kişisel verilerinizin işlenip işlenmediğini öğrenme,</li>
                  <li>Kişisel verileriniz işlenmişse buna ilişkin bilgi talep etme,</li>
                  <li>Kişisel verilerinizin işlenme amacını ve bunların amacına uygun kullanılıp kullanılmadığını öğrenme,</li>
                  <li>Yurt içinde veya yurt dışında kişisel verilerinizin aktarıldığı üçüncü kişileri bilme,</li>
                  <li>Kişisel verilerinizin eksik veya yanlış işlenmiş olması halinde bunların düzeltilmesini isteme,</li>
                  <li>KVKK'nın 7. maddesinde öngörülen şartlar çerçevesinde kişisel verilerinizin silinmesini veya yok edilmesini isteme,</li>
                  <li>Düzeltme, silme ve yok edilme işlemlerinin kişisel verilerin aktarıldığı üçüncü kişilere bildirilmesini isteme,</li>
                  <li>İşlenen verilerin münhasıran otomatik sistemler vasıtasıyla analiz edilmesi suretiyle aleyhinize bir sonucun ortaya çıkmasına itiraz etme,</li>
                  <li>Kişisel verilerinizin kanuna aykırı olarak işlenmesi sebebiyle zarara uğramanız halinde zararın giderilmesini talep etme.</li>
                </ul>

                <h2 className="text-2xl font-bold text-navy mt-8">7. Başvuru Yöntemi</h2>
                <p>
                  Yukarıda belirtilen haklarınızı kullanmak için kimliğinizi tespit edici gerekli bilgiler ile KVKK'nın 11. maddesinde belirtilen haklardan kullanmayı talep ettiğiniz hakkınıza yönelik açıklamalarınızı içeren talebinizi; lhglobalpass@gmail.com e-posta adresine veya Fevzi Paşa Mah. 847/1 Sk. No:8 Kat:4 Daire:4/405 Sağlık İş Hanı Konak/İzmir adresine yazılı olarak iletebilirsiniz.
                </p>

                <h2 className="text-2xl font-bold text-navy mt-8">8. Veri Güvenliği</h2>
                <p>
                  Şirketimiz, kişisel verilerin hukuka aykırı olarak işlenmesini ve erişilmesini önlemek, kişisel verilerin muhafazasını sağlamak amacıyla uygun güvenlik düzeyini temin etmeye yönelik gerekli teknik ve idari tedbirleri almaktadır.
                </p>

                <h2 className="text-2xl font-bold text-navy mt-8">9. İletişim</h2>
                <p>
                  KVKK kapsamındaki sorularınız ve talepleriniz için bizimle iletişime geçebilirsiniz:
                  <br />
                  <strong>E-posta:</strong> lhglobalpass@gmail.com
                  <br />
                  <strong>Telefon:</strong> +90 542 267 11 71
                  <br />
                  <strong>Adres:</strong> Fevzi Paşa Mah. 847/1 Sk. No:8 Kat:4 Daire:4/405 Sağlık İş Hanı Konak/İzmir
                </p>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
      <WhatsAppButton />
    </div>
  );
};

export default KVKKPage;
